import React, { Component } from "react";

import { withRequest } from "../../../utils/request";
import Pagination from "../../general/Pagination";
import Modal from "../../general/Modal";
import Create from "./Create";
import Edit from "./Edit";
import Loader from "../../general/Loader";
import { Link } from "react-router-dom";
import { getLink } from "../../../utils/helpers";

class Grupos extends Component {
    state = {
        grupos: {},
        grupo: {},
        links: null,
        showCreate: false,
        showEdit: false,
        loading: true,
    };
    componentDidMount() {
        this.getGrupos();
    }
    getGrupos = async (url = null) => {
        url = url ? url : "grupos";
        const grupos = await this.props.request(url);

        if (grupos.data) {
            this.setState({
                grupos: grupos.data,
                loading: false,
            });
        }
    };
    toggleCreateModal = () => {
        this.setState({
            showCreate: !this.state.showCreate,
            grupo: {},
        });
    };
    toggleEditModal = (grupo) => {
        this.setState({
            showEdit: !this.state.showEdit,
            grupo: grupo,
        });
    };
    render() {
        const { grupos, loading } = this.state;
        return (
            <div>
                <div className='page-header'>
                    <Link to={getLink('/configuracion/')}>&laquo; Volver a configuración</Link>
                    <h1 className='page-title row'>
                        <span className='col'>Grupos de Productos</span>
                        <button
                            className='au-btn au-btn-icon au-btn--green au-btn--small'
                            onClick={this.toggleCreateModal}>
                            <i className='zmdi zmdi-plus' />
                            Añadir Grupo
                        </button>
                    </h1>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div>
                            {loading && <Loader />}
                            {!grupos.length ? (
                                <div>
                                    {!loading && (
                                        <div>
                                            Todavía no hay grupos creados.
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className='table-data'>
                                    <table className='table table-data2'>
                                        <thead>
                                            <tr>
                                                <th>Nombre</th>
                                                <th>Items</th>
                                                <th />
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {grupos.map((grupo) => (
                                                <tr
                                                    className='tr-shadow'
                                                    key={grupo.id}>
                                                    <td>{grupo.nombre}</td>
                                                    <td>{grupo.items}</td>
                                                    <td>
                                                        <div className='table-data-feature'>
                                                            <button
                                                                className='item'
                                                                data-toggle='tooltip'
                                                                data-placement='top'
                                                                title=''
                                                                data-original-title='Edit'
                                                                onClick={() => {
                                                                    this.toggleEditModal(
                                                                        grupo
                                                                    );
                                                                }}>
                                                                <i className='zmdi zmdi-edit' />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    {this.state.links && (
                                        <Pagination
                                            links={this.state.links}
                                            meta={this.state.meta}
                                            getData={this.getGrupos}
                                        />
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <Modal
                    show={this.state.showCreate}
                    blank={true}
                    toggle={this.toggleCreateModal}>
                    <Create
                        toggle={this.toggleCreateModal}
                        grupo={this.state.grupo}
                        getGrupos={this.getGrupos}
                    />
                </Modal>
                <Modal
                    show={this.state.showEdit}
                    blank={true}
                    toggle={() => this.toggleEditModal({})}>
                    <Edit
                        toggle={() => this.toggleEditModal({})}
                        grupo={this.state.grupo}
                        getGrupos={this.getGrupos}
                    />
                </Modal>
            </div>
        );
    }
}

export default withRequest(Grupos);
